<template>
  <IviewModal v-bind="$attrs" title="切换组织" @on-ok="save" @on-cancel="close" size="large">
    <div class="micro-org-content">
      <IviewInput v-model="searchVal" placeholder="输入搜索内容" class="ipt">
        <div class="btn" slot="suffix" @click="getList({ groupName: searchVal })">
          <Icon type="ios-search" slot="suffix" class="icon" />
          <span>搜索</span>
        </div>
      </IviewInput>
      <ul class="org-list">
        <li
          v-for="(item, i) in organList"
          :key="item.groupId"
          :class="{ active: item.groupId == defaultOrg }"
          @click="organClick(item)"
        >
          <div class="head">
            <img src="~_img/common/organ-img.png" alt="" />
            <div class="t1">{{ item.groupName }}</div>
          </div>
          <div class="role1">
            <div class="left">
              <img src="~_img/common/user1.png" alt="" />
              <div class="t1">角色:</div>
            </div>
            <div class="right">
              <div
                class="text"
                v-for="(role, k) in item.roles"
                @click="() => item.groupId == defaultOrg && roleClick(item, role)"
                :class="{ active: role.defaultRole == 1 }"
                :key="k"
              >
                {{ role.roleName }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </IviewModal>
</template>

<script>
import actions from '@/utils/actions'
import { getUserInfo } from '@/utils/common.js'
export default {
  name: 'switchOrg',
  data() {
    return {
      organList: [],
      defaultOrg: '',
      defaultRole: '',
      searchVal: ''
    }
  },
  watch: {
    '$parent.orgPopup': {
      handler(n) {
        n && this.getList();
      },
      immediate: true
    }
  },
  created() {
  },
  methods: {
    getList(params = {}) {
      this.$api.config.getOrganSelect({ ...params, belongGroup: 1 }).then((res) => {
        let data = res.data.map((item) => ({ ...item, label: item.groupName, value: item.groupId }))
        this.organList = data
        this.getDefaultOrgan()
      })
    },
    organClick(item) {
      this.defaultOrg = item.groupId
      let role = item.roles.find((item) => Boolean(item.defaultRole))
      if (role) {
        this.defaultRole = role.roleId
      } else {
        this.defaultRole = undefined
      }
    },
    roleClick(item, role) {
      item.roles.map((item) => (item.defaultRole = 0))
      role.defaultRole = 1
      this.defaultRole = role.roleId
    },
    save() {
      if (this.defaultOrg) {
        if (this.defaultRole || this.defaultRole == 0) {
          this.setDefaultOrgan()
        } else {
          this.$Message.warning('请选择默认角色')
        }
      } else {
        this.$Message.warning('请选择默认组织')
      }
    },
    async setDefaultOrgan() {
      let data = this.organList.find((item) => item.groupId == this.defaultOrg)
      if (data.belongGroup == 0) {
        this.$alert('所选组织未设置所属部门，请联系管理员进行设置。', '提示', {
          confirmButtonText: '确定'
        })
      } else {
        let { id } = await getUserInfo()
        this.$api.config.putDefaultOrgan({}, [id, this.defaultOrg]).then(async (res) => {
          this.setDefauleRole()
        })
      }
    },
    async setDefauleRole() {
      let { id } = await getUserInfo()
      this.$api.config.putDefauleRole({}, [id, this.defaultOrg, this.defaultRole]).then(async (res) => {
        this.$Message.success('切换成功')
        this.close()
        await getUserInfo(true)
        location.reload()
      })
    },
    getDefaultOrgan() {
      let data = this.organList.find((item) => item.defaultGroup == 1)
      if (data) {
        this.defaultOrg = data.groupId
        let role = data.roles.find((item) => Boolean(item.defaultRole))
        this.defaultRole = role.roleId
      }
    },
    close() {
      actions.setGlobalState({ showChangeOrgan: false })
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.micro-org-content {
  height: 650px;
  padding: 42px 40px 42px 60px;
  .ipt {
    /deep/.ivu-input-wrapper {
      width: 356px !important;
      input {
        height: 36px;
      }
    }
    .btn {
      background: #ededed;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #e9e9e9;
      position: absolute;
      right: -2px;
      width: 92px;
      height: 100%;
      line-height: 36px;
      font-size: 16px;
      color: #a1a1a1;
      cursor: pointer;
      .icon {
        font-size: 20px;
        vertical-align: middle;
        margin-right: 4px;
      }
    }
  }
  .org-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 18px;
    li {
      width: 350px;
      height: 135px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(201, 208, 228, 0.4), 0px 1px 5px 0px #e1e8f0;
      border-radius: 4px;
      padding: 10px 4px 10px 14px;
      margin: 0 26px 26px 0;
      .head {
        display: flex;
        align-items: center;
        img {
          width: 30px;
          margin-right: 10px;
        }
        .t1 {
          font-size: 14px;
          color: #333333;
        }
      }
      .role1 {
        display: flex;
        margin-top: 10px;
        .left {
          display: flex;
          img {
            width: 24px;
            height: 26px;
            margin-right: 4px;
            margin-left: 2px;
          }
          .t1 {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #636363;
            margin: 0 4px 0 10px;
          }
        }
        .right {
          display: flex;
          flex-wrap: wrap;
          flex: 1;
          height: 60px;
          overflow: auto;
          .text {
            height: 26px;
            line-height: 26px;
            background: #f5f5f5;
            padding: 0 12px;
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: #595959;
            margin: 0 14px 13px 0;
            cursor: pointer;
          }
          .text.active {
            background: #f2f6ff;
            border: 1px solid #456bd1;
            font-size: 12px;
            color: #456bd1;
          }
        }
      }
    }
    li.active {
      background: #f7fbff;
      box-shadow: 0px 4px 10px 0px rgba(201, 208, 228, 0.4), 0px 1px 5px 0px #e1e8f0,
        inset 1px 1px 3px 0px rgba(174, 188, 255, 0.5);
      border-radius: 4px;
      border: 1px solid #8da5e9;
    }
  }
}
</style>
